import { NavBar } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { ExpenseStatusEnum } from "@src/__generated__/urql-graphql";
import { can } from "@src/utils/components/permissions";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import type React from "react";
import type { FunctionComponent } from "react";
import type { StoreExpenses } from "./StoreExpenses";
import { QuickFilters } from "./StoreExpenses";

export const TabTableNavigation: FunctionComponent<
  React.PropsWithChildren<{ store: StoreExpenses }>
> = observer(function TabTableNavigation({ store }) {
  const { workspaceStore } = useStore();

  return (
    <NavBar>
      <NavBar.Item
        active={
          !store.isExpenseItemsView &&
          store.activeQuickFilter?.value.length === 0
        }
        onClick={() => {
          store.setActiveView("default");
          store.activeQuickFilter?.clear();
        }}
      >
        <Trans>All</Trans>
      </NavBar.Item>

      <NavBar.Item
        active={
          !store.isExpenseItemsView &&
          store.activeQuickFilter?.value[0] === ExpenseStatusEnum.Approved
        }
        onClick={() => {
          store.setActiveView("default");
          store.activeQuickFilter?.setValue(ExpenseStatusEnum.Approved);
        }}
      >
        <Trans>Approved</Trans>
      </NavBar.Item>

      <NavBar.Item
        active={
          !store.isExpenseItemsView &&
          store.activeQuickFilter?.value[0] === ExpenseStatusEnum.ForApproval
        }
        onClick={() => {
          store.setActiveView("default");
          store.activeQuickFilter?.setValue(ExpenseStatusEnum.ForApproval);
        }}
      >
        <Trans>For Items Approval</Trans>
      </NavBar.Item>

      <NavBar.Item
        active={
          !store.isExpenseItemsView &&
          store.activeQuickFilter?.value[0] ===
            ExpenseStatusEnum.ForFinancialApproval
        }
        onClick={() => {
          store.setActiveView("default");
          store.activeQuickFilter?.setValue(
            ExpenseStatusEnum.ForFinancialApproval,
          );
        }}
      >
        <Trans>For Financial Approval</Trans>
      </NavBar.Item>

      <NavBar.Item
        active={
          !store.isExpenseItemsView &&
          store.activeQuickFilter?.value[0] === ExpenseStatusEnum.Draft
        }
        onClick={() => {
          store.setActiveView("default");
          store.activeQuickFilter?.setValue(ExpenseStatusEnum.Draft);
        }}
      >
        <Trans>Drafts</Trans>
      </NavBar.Item>

      {workspaceStore.settings?.enableExpenseEmailImport &&
        can("expense_accessImported") && (
          <NavBar.Item
            active={
              !store.isExpenseItemsView &&
              store.activeQuickFilter?.value[0] === ExpenseStatusEnum.Imported
            }
            onClick={() => {
              store.setActiveView("default");
              store.activeQuickFilter?.setValue(ExpenseStatusEnum.Imported);
            }}
          >
            <Trans>Imported</Trans>
          </NavBar.Item>
        )}

      <NavBar.Item
        active={store.isExpenseItemsView}
        onClick={() => store.setActiveView(QuickFilters.ExpenseItems)}
      >
        <Trans>Expense items</Trans>
      </NavBar.Item>
    </NavBar>
  );
});
